export default __webpack_public_path__ + "static/media/raregotchi.6c0ee6ff.svg";